import React, { PropsWithChildren, useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid';


const FlexiSetFilterWrapper: React.FunctionComponent<PropsWithChildren<{ title: string }>> = ({ children, title }) => {

	const [open, setOpen] = useState(true);

	return <div className="wrapper space-y-2">
		<header className="relative flex justify-between items-center group text-sm font-semibold text-gray-900 cursor-pointer hover:text-gray-700" onClick={()=> setOpen(!open)}>
			<p>{title}</p>
			<p>
				{open ? <ChevronUpIcon className="w-4 h-4 flex-none" /> : <ChevronDownIcon className="w-4 h-4 flex-none" />}
			</p>
		</header>
		{open && children}
	</div>;
};

export default FlexiSetFilterWrapper;